import type { Label } from '../../../lib/tasksApi';

/**
 * CLE-179 — Linear-style label pill for the task row.
 *
 * Differs from the shared `LabelPill` (which uses a saturated colour fill):
 * Linear renders row labels as an outlined chip with a transparent background,
 * a 6px colour dot, and muted text — 11px / 500, 1px solid #3f3f46 border,
 * fully-rounded, padding 1px 8px, text #d4d4d8.
 */
export function LinearLabelPill({ label, onClick }: { label: Label; onClick?: () => void }) {
  return (
    <button
      type="button"
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation();
              onClick();
            }
          : undefined
      }
      title={onClick ? `Filtrează după ${label.name}` : label.name}
      className="group/label inline-flex items-center gap-1.5 rounded-full border border-gray-300 px-2 py-px text-[11px] font-medium text-gray-700 transition-colors hover:border-gray-400"
      style={{ paddingTop: 1, paddingBottom: 1 }}
    >
      <span
        className="inline-block h-1.5 w-1.5 shrink-0 rounded-full"
        style={{ backgroundColor: label.color }}
      />
      {label.name}
    </button>
  );
}
